import { Message } from "./Message";

export class Messages
{
    static login(token: string): Message
    {
        return {
            scope: "namirasoft",
            name: "account",
            action: "login",
            result: "successful",
            token
        };
    }
    static logout(token: string): Message
    {
        return {
            scope: "namirasoft",
            name: "account",
            action: "logout",
            result: "successful",
            token
        };
    }
    static isTheSame(a: Message, b: Message)
    {
        if (a.scope === b.scope)
            if (a.name === b.name)
                if (a.action === b.action)
                    if (a.result === b.result)
                        return true;
        return false;
    }
    static isLogin(message: Message)
    {
        try
        {
            return Messages.isTheSame(Messages.login(""), message);
        } catch (error)
        {
        }
        return false;
    }
    static isLogout(message: Message)
    {
        try
        {
            return Messages.isTheSame(Messages.logout(""), message);
        } catch (error)
        {
        }
        return false;
    }
}